import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import DatePicker, { DateObject } from "react-multi-date-picker";
import Handler from "../../../Helpers/Handler";
import { useDispatch } from "react-redux";
import { contentLoadingChange } from "../../../Reducer/componentSlice";

const DLStage = ({ customerDetails, onVerified }) => {
    const dispatch = useDispatch()
    const [dlData, setDlData] = useState({ dlNo: "", dob: null });
    const [loading, setLoading] = useState(false);
    const [frontImage, setFrontImage] = useState(null);
    const [backImage, setBackImage] = useState(null);
    const [frontPreview, setFrontPreview] = useState(null);
    const [backPreview, setBackPreview] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDlData((prev) => ({ ...prev, [name]: value.toUpperCase() }));
    };

    const handleImageChange = (side) => (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (side === "front") {
            setFrontImage(file);
            setFrontPreview(URL.createObjectURL(file));
        } else {
            setBackImage(file);
            setBackPreview(URL.createObjectURL(file));
        }
    };

    const submitDl = async () => {
        if (!dlData.dlNo) {
            toast.error("Enter Driving Licence Number");
            return;
        }
        if (!dlData.dob) {
            toast.error("Select Date of Birth");
            return;
        }
        if (!frontImage || !backImage) {
            toast.error("Upload front and back images of the driving licence");
            return;
        }
        try {
            dispatch(contentLoadingChange(true))
            setLoading(true);
            const formData = new FormData();
            formData.append("dlNo", dlData.dlNo);
            formData.append("dob", dlData.dob.format("DD-MM-YYYY"));
            formData.append("frontImage", frontImage);
            formData.append("backImage", backImage);
            const response = await Handler({ method: "patch", url: `/admin/customer/${customerDetails?.customerId}/kyc/dl/verify`, data: formData, formdata: true });
            if (response?.success) {
                toast.success(response?.data?.message || "DL data fetched, pending verification");
                dispatch(contentLoadingChange(false))
                setLoading(false);
                // Close the dialog and refresh the customer (this used to reload the whole browser page).
                onVerified?.();
            } else {
                toast.error(response?.data?.message || "Submission failed");
                setLoading(false);
                dispatch(contentLoadingChange(false))
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
            dispatch(contentLoadingChange(false));
        }
    };
    const parseDOB = (dateStr) => {
        if (!dateStr) return null;
        const parts = String(dateStr).split("-");
        if (parts.length !== 3) return null;
        const [day, month, year] = parts;
        return new DateObject({ day: Number(day), month: Number(month), year: Number(year) });
    };

    useEffect(() => {
        const dlDob = customerDetails?.kyc?.dl?.dlData?.dateOfBirth;
        const aadhaarDob = customerDetails?.kyc?.aadhaar?.aadhaarDetails?.proofOfIdentity?.dob;
        setDlData({
            dlNo: customerDetails?.kyc?.dl?.dlNo || "",
            dob: dlDob ? parseDOB(dlDob) : aadhaarDob ? parseDOB(aadhaarDob) : null
        });
        setFrontImage(null);
        setBackImage(null);
        setFrontPreview(null);
        setBackPreview(null);
    }, [customerDetails])

    return (
        <>
            <div className="mb-3">
                <label className="form-label">Driving Licence No</label>
                <input type="text" name="dlNo" autoComplete="off" disabled={loading} className="form-control" value={dlData.dlNo} onChange={handleChange} placeholder="Enter DL Number" />
            </div>
            <div className="mb-3">
                <label className="form-label w-100">  Date Of Birth</label>
                <DatePicker value={dlData.dob} maxDate={new Date()} minDate={new Date(1940, 0, 1)} format="DD/MM/YYYY" inputClass="form-control" autoComplete="off" disabled={loading} onChange={(val) => setDlData((prev) => ({ ...prev, dob: val }))} />
            </div>
            <div className="row mb-3">
                <div className="col-6 text-center">
                    <label className="form-label d-block">Front Image</label>
                    {frontPreview && (
                        <img src={frontPreview} alt="DL front" className="img-fluid rounded border mb-2" style={{ height: '140px', objectFit: "cover" }} />
                    )}
                    <input type="file" accept="image/*" disabled={loading} className="form-control" onChange={handleImageChange("front")} />
                </div>
                <div className="col-6 text-center">
                    <label className="form-label d-block">Back Image</label>
                    {backPreview && (
                        <img src={backPreview} alt="DL back" className="img-fluid rounded border mb-2" style={{ height: '140px', objectFit: "cover" }} />
                    )}
                    <input type="file" accept="image/*" disabled={loading} className="form-control" onChange={handleImageChange("back")} />
                </div>
            </div>
            <div className="mb-3 text-center">
                <button className="btn btn-primary" onClick={submitDl} disabled={loading}>{loading ? "Submitting..." : "Submit"}</button>
            </div>
        </>
    );
};

export default DLStage;